import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { FaShieldAlt } from "react-icons/fa";
import { FaBoltLightning } from "react-icons/fa6";
import { RiGlobalLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { loginUser } from "../../api/api";
import { useAuth } from "../../context/AuthContext";
import AuthLayout from "../layout/AuthLayout";
import AuthBranding from "./AuthBranding";
import FormInput from "./FormInput";
import "../custom.css";

const signinFeatures = [
  { icon: <FaShieldAlt size={22} color="#6FE6B8" />, text: "Secure & Encrypted" },
  { icon: <FaBoltLightning size={22} color="#6FE6B8" />, text: "Lightning Fast" },
  { icon: <RiGlobalLine size={22} color="#6FE6B8" />, text: "Global Access" },
];

const Signin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await loginUser({ email, password });
      if (response.success === false) {
        toast.error(response.message);
      } else {
        toast.success(response.message);
        setTimeout(() => {
          navigate("/verify-signin", { state: { email } });
        }, 2000);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const contentPanel = (
    <AuthBranding
      titlePrefix="Welcome"
      accentText="Back"
      subtitle="Sign in to access your Binaxpay account and manage your crypto payment gateway services."
      features={signinFeatures}
    />
  );

  const formPanel = (
    <>
      <h2>Sign In</h2>
      <p className="form-subtitle">
        Enter your credentials to access your account
      </p>

      <form className="auth-form" onSubmit={handleSubmit}>
        {/* Email */}
        <FormInput
          label="Email"
          type="email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={<FaEnvelope />}
          required
        />

        {/* Password */}
        <FormInput
          label="Password"
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          icon={<FaLock />}
          required
          className="mb-2"
        />

        {/* Forgot Password Link */}
        <div className="text-end mt-1 mb-2">
          <Link to="/forgot" className="forgot-password-link">
            Forgot password?
          </Link>
        </div>

        {/* Remember Me */}
        <div className="form-options">
          <div className="remember-me">
            <input type="checkbox" id="remember" name="remember" />
            <label htmlFor="remember">Remember me</label>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="btn btn-signin btn-block"
          disabled={loading}
        >
          {loading ? "Signing In..." : "Sign In"}
        </button>

        {/* Footer */}
        <div className="auth-footer">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </div>
      </form>
    </>
  );

  return (
    <AuthLayout
      contentPosition="left"
      contentPanel={contentPanel}
      formPanel={formPanel}
    />
  );
};

export default Signin;
